import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ProductDetailDescriptionView } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { getContactLensFeatures } from '../../utils/get-contactlens-features.js';
import '@grandvisionhq/inventory';
import { ProductDetailLensesFeatures } from '../ProductDetailLensesFeatures/ProductDetailLensesFeatures.js';

const LensesDescription = ({ className  })=>{
    const { getLabel  } = useIntl();
    const { activeVariant  } = useProductDetailContext();
    const labels = React.useMemo(()=>({
            description: activeVariant.description,
            header: activeVariant.header
        })
    , [
        activeVariant
    ]);
    const { lensFeatures  } = React.useMemo(()=>getContactLensFeatures(activeVariant, getLabel)
    , [
        getLabel,
        activeVariant
    ]);
    return /*#__PURE__*/ React.createElement(ProductDetailDescriptionView, {
        header: labels.header,
        className: className,
        description: labels.description
    }, /*#__PURE__*/ React.createElement(ProductDetailLensesFeatures, swcHelpers.extends({}, lensFeatures)));
};

export { LensesDescription };
//# sourceMappingURL=LensesDescription.js.map
